import { clearInputData } from './form'

class Popup {
	#popupContainer
	#closeButton

	constructor(popupId, options = {}) {
		this.popupId = popupId
		this.events = options.on || {}
		this.#popupContainer = document.querySelector(`${this.popupId}`)
		this.#closeButton = this.#popupContainer.querySelector('.close')
	}

	#preventTouches(e) {
		const isTouchInside = !!e.target.closest('.popup__content')
		if (!isTouchInside) {
			e.preventDefault()
		}
	}

	#disableBodyScroll() {
		document.body.classList.add('scroll-lock')
		document.addEventListener('touchmove', this.#preventTouches, {
			passive: false
		})
	}

	#enableBodyScroll() {
		document.body.classList.remove('scroll-lock')
		document.removeEventListener('touchmove', this.#preventTouches, {
			passive: false
		})
	}

	#closeWhenClickOutside({ target }) {
		if (target.contains(this.#popupContainer)) {
			this.close()
		}
	}

	#closeOnEsc({ key }) {
		if (key === 'Escape' && this.#popupContainer.classList.contains('active')) {
			this.close()
		}

		const currenActiveInout = document.querySelector('input:focus')

		if (key === 'Escape' && currenActiveInout) {
			currenActiveInout.blur()
		}
	}

	show() {
		this.#popupContainer.classList.add('active')
		this.#disableBodyScroll()

		this.#closeButton.addEventListener('click', (e) => this.close(e))
		document.addEventListener('click', (e) => this.#closeWhenClickOutside(e))
		document.addEventListener('keydown', (e) => this.#closeOnEsc(e))
	}

	close() {
		localStorage.removeItem('isShowPopup')
		this.#popupContainer.classList.remove('active')
		this.#enableBodyScroll()
		this.events.close && this.events.close()
	}
}

document.addEventListener('DOMContentLoaded', () => {
	if (localStorage.getItem('isShowPopup') === 'on') {
		const popup = new Popup('#popup-success')
		popup.show()
		;``
	}
})

const showPopupBtns = document.querySelectorAll('[data-show-popup]')

showPopupBtns.forEach((btn) => {
	btn.addEventListener('click', () => {
		const popupForm = document.querySelector(`#${btn.dataset.showPopup} form`)

		const popup = new Popup(`#${btn.dataset.showPopup}`, {
			on: {
				close: () => {
					if (popupForm) {
						const inputs = popupForm.querySelectorAll('input')
						inputs.forEach((input) => clearInputData(input))
					}
				}
			}
		})
		popup.show()
	})
})
